// extracted by mini-css-extract-plugin
export default {"modalOverlay":"DD-z","modalContent":"ED-z","header":"FD-z","close":"GD-z"};